<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("cinema", 2) }}
        </div>
        <div class="section-subTitle my-2">{{ $t("cinemalist_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="
            cinema_manager_add_edit_disabled != 3 && $can('create', 'Cinemas')
          "
          variant="default"
          to="add-cinema"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="searchCinemasList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div>
          <!-- <select
            v-model="selectedStatus"
            @change="handleStatusChange"
            style="height: 35px; border-radius: 10px"
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="all">All</option>
          </select> -->
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                handleChange(filterIsActive);
              }
            "
          />
        </div>
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          v-if="GridViewFlag"
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          v-if="GridViewFlag"
          class="btnj btn-listView"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 150px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th class="text-left" style="width: 150px">
            <span class="pr-3">{{ $tc("Cinema Code", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'cine_name'"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('cine_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("cinema", 1) }}
          </th>
          <!-- <th class="text-center">
            <span>{{ $tc("setting", 2) }}</span>
          </th> -->
        </tr>
      </thead>
      <tbody v-if="Cinemas.length > 0">
        <tr v-for="(item, key) in filteredCinemas" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.cine_is_active === 'Y' ? 'active' : 'inactive'"
              />
              <span
                v-if="
                  cinema_manager_add_edit_disabled != 3 &&
                  $can('update', 'Cinemas')
                "
                class="edit-icon ml-4 blue-icon"
                @click="goToRoute('/cinema-manager/edit-cinema', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </span>
              <span
                class="view-icon ml-2 blue-icon"
                @click="goToRoute('/cinema-manager/view-cinema', item)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </span>
            </div>
          </td>
          <td>{{ $tc(item.cine_code, 1) }}</td>
          <!-- {{item.cine_id}}1 2{{item.cine_setting_id}} -->
          <td>{{ $tc(item.cine_name, 1) }}</td>
          <!-- <td class="text-center">
            <b-button
              v-if="item.isEdit"
              variant="default"
              :to="{
                path: '/cinema-manager/view-cinema-settings',
                query: {
                  cinema_id: item.cine_id,
                  cinema_setting_id: item.cine_setting_id,
                },
              }"
              class="btn-blue"
              >{{ $t("view") }} {{ $tc("setting", 2) }}</b-button
            >
            <b-button
              v-else-if="$can('create', 'Cinemas')"
              variant="default"
              :to="{
                path: '/cinema-manager/add-cinema-settings',
                query: { cinema_id: item.cine_id },
              }"
              class="btn-blue"
              >{{ $t("add") }} {{ $tc("setting", 2) }}</b-button
            >
          </td> -->
        </tr>
      </tbody>
      <tbody v-if="Cinemas.length == 0">
        <tr>
          <td colspan="4">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Cinemas.length > 0"
        v-for="(item, key) in Cinemas"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.cine_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/cinema-manager/edit-cinema', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/cinema-manager/view-cinema', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot
                :status="item.cine_is_active === 'Y' ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Cinemas from "@/helper/formJSONMaster/Cinemas";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      cinema_manager_add_edit_disabled: null,
      cinema_id: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      cine_setting_id: "",
      gridView: false,
      listView: true,
      Methods: Cinemas.Methods,
      Cinemas: [],
      CinemaSetting: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      CinemasCopy: [],
      searchValue: "",
      searchKey: "Cinema Name",
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      selectedStatus: "Y",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },

    filteredCinemas() {
      console.log("check=>", this.selectedStatus);
      if (this.selectedStatus === "Y") {
        return this.Cinemas.filter((cinema) => cinema.cine_is_active === "Y");
      } else if (this.selectedStatus === "N") {
        return this.Cinemas.filter((cinema) => cinema.cine_is_active === "N");
      } else if (this.selectedStatus === "A") {
        return this.Cinemas;
      }
    },
  },

  methods: {
    handleChange: function (status) {
      console.log("status=>", status);
      this.selectedStatus = status;
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCinemasList(this.cinema_id);
      } else {
        this.currentPage = event;
        this.getCinemasList(this.cinema_id);
      }
    },
    goToRoute: function (path, item) {
      const { cine_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: cine_id,
        },
      });
    },
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getCinemasList();
    },
    searchCinemasList: function (search) {
      this.getCinemasList(undefined, 1, search);
    },
    getCinemasList: function (cinema_id, page = undefined, search = undefined) {
      this.Cinemas = [];
      let payload = {
        limit: this.perPage,
        currentPage: page ? page : this.currentPage,
        cinema_id: this.cinema_id,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderBy,
      };
      MasterService.GetCinemaList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Cinemas = data.Records;
              //  this.Cinemas = data.Records.filter(cinema => cinema.cine_is_active === 'Y');
              this.CinemaSetting = [];

              MasterService.GetCinemaSettingList().then((res) => {
                const { data } = res;
                this.CinemaSetting = data.Records;

                this.Cinemas = this.Cinemas.map((x) => {
                  this.CinemaSetting.map((y) => {
                    if (x.cine_id == y.cinema_setting_id) {
                      this.cine_setting_id = y.cine_setting_id;
                      x["isEdit"] = true;
                      x["cine_setting_id"] = y.cine_setting_id;
                    }
                  });
                  return x;
                });
              });
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemasComponents/cinemas.vue